import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css'; // Ensure styles are applied from projects.css

const korolevAdminImages = [
  { id: 1, thumbnail: '../images/korolev-admin/full_0eEAPskH.jpg', fullImage: '../images/korolev-admin/full_0eEAPskH.jpg' },
  { id: 2, thumbnail: '../images/korolev-admin/full_BYiClz26.jpg', fullImage: '../images/korolev-admin/full_BYiClz26.jpg' },
  { id: 3, thumbnail: '../images/korolev-admin/full_dc5urOXk.jpg', fullImage: '../images/korolev-admin/full_dc5urOXk.jpg' },
  { id: 4, thumbnail: '../images/korolev-admin/full_nquBqAIX.jpg', fullImage: '../images/korolev-admin/full_nquBqAIX.jpg' },
  { id: 5, thumbnail: '../images/korolev-admin/full_PZddwcJe.jpg', fullImage: '../images/korolev-admin/full_PZddwcJe.jpg' },
  { id: 6, thumbnail: '../images/korolev-admin/full_wxHovOGe.jpg', fullImage: '../images/korolev-admin/full_wxHovOGe.jpg' },
];

function KorolevAdmin() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/projects');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : korolevAdminImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < korolevAdminImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ПРОЕКТЫ</button>
      <h1>Здание администрации, Королев</h1>
      <div className="project-detail-grid">
        {korolevAdminImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Korolev Admin Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ПРОЕКТЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={korolevAdminImages[selectedImageIndex].fullImage} alt={`Korolev Admin Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default KorolevAdmin; 